export default __webpack_public_path__ + "static/media/01-SUNIL K SHIVANAGI.226856f9.jpg";